module.exports = __webpack_public_path__ + "static/fcc_javascript_algorithms_and_datastructures-d0945e4f7c0712f4d8853be58c5e62e1.pdf";